import buildNumber from '../build_number.json'
const appConfig = window.appConfig || {}
window.appConfig = {
	...appConfig,
	env: appConfig.env || import.meta.env?.VITE_ENV || 'dev',
	pusherAppKey: appConfig.pusherAppKey || import.meta.env.VITE_PUSHER_APP_KEY,
	buildNumber: buildNumber.build_number,
}

import Favico from 'favico.js'
window.Favico = Favico
window.favicon = new Favico({
	animation: 'slide',
})

import { reactive } from 'vue'
import bus from '@/helpers/bus'
window.EventBus = bus
import 'maz-ui/css/main.css'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput.mjs'
import app from './app'
import i18n, { PREFERRED_LOCALE, loadLocaleAsync } from '@/i18n'
import './sass/_common.scss'
import router from './router'
import { startCapturingConsole } from '@/helpers/log'
import Bugsnag from '@bugsnag/js'
import BugsnagVue from '@bugsnag/plugin-vue'
import {
	focusDirective,
	safeHtmlDirective,
	onClickOutsideDirective,
	MomentPlugin,
	EventBusPlugin,
	checkForRedirectToDownload,
} from '@/helpers/utils'
import {
	switchGlobalColorScheme,
	getColorSchemePreference,
} from '@/helpers/colors'
import { MediaModalPlugin, AlertPlugin } from '@/components/common'
import { RecycleScroller } from 'vue-virtual-scroller'
import VueLazyLoad from 'vue3-lazyload'
import { setupCalendar } from 'v-calendar'
import { startSession } from '@/helpers/session'
import { fetchEmojiDataForLocale } from '@/helpers/emojis'

app.use(i18n)
app.use(router)
app.use(setupCalendar)

checkForRedirectToDownload()

app.component('RecycleScroller', RecycleScroller)
app.component('pronto-phone-number-input', MazPhoneNumberInput)

app.directive('focus', focusDirective)
app.directive('safeHtml', safeHtmlDirective)
app.directive('onClickOutside', onClickOutsideDirective)

app.directive('init', {
	bind: function (el, binding, vnode) {
		vnode.context[binding.arg] = binding.value
	},
})

loadLocaleAsync(PREFERRED_LOCALE)
fetchEmojiDataForLocale(PREFERRED_LOCALE)

app.use(MediaModalPlugin)
app.use(AlertPlugin)
app.use(MomentPlugin)
app.use(EventBusPlugin)
app.use(VueLazyLoad, {
	preLoad: 1.3,
	error: 'dist/error.png',
	loading: '/images/common/missing_profile_img.png',
	attempt: 1,
})

const observed = reactive({
	accessibility: false,
})

app.mixin({
	watch: {
		accessibilityMode: function (val, oldVal) {
			if (!oldVal && val) {
				EventBus.$emit('closeMessageActions')
			}

			if (oldVal && !val) {
				const borderelm = document.querySelector(
					'.accessibility-highlight-border'
				)
				borderelm.style.display = 'none'
			}
		},
	},

	computed: {
		accessibilityMode: {
			get: () => {
				return observed.accessibility
			},

			set: (accessible) => {
				observed.accessibility = accessible
				if (!accessible) {
					const el = document.querySelector('.pronto-container')
					el.tabIndex = 1
					el.focus()
					el.tabIndex = -1
				}
			},
		},
	},
})

if (window.appConfig.env === 'local') {
	// always capture logs in local environment
	startCapturingConsole()
}

const scheme = getColorSchemePreference()
switchGlobalColorScheme(scheme)

const {
	VITE_BUGSNAG_API_KEY,
	VITE_BUGSNAG_NOTIFY_RELEASE_STAGES,
} = import.meta.env
const $bugsnag = Bugsnag.start({
	apiKey: VITE_BUGSNAG_API_KEY,
	plugins: [new BugsnagVue()],
	enabledReleaseStages: ['production'],
	enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
	maxBreadcrumbs: 100,
	releaseStage: VITE_BUGSNAG_NOTIFY_RELEASE_STAGES,
})
Object.assign(app.config.globalProperties, { $bugsnag })

const bugsnagVue = Bugsnag.getPlugin('vue')
app.use(bugsnagVue)

router.isReady().then(() => {
	startSession()
	app.mount('#app')
})
